<div [ngClass]="datepickerClasses()" class="datepicker-form-control">
  @if (label()) {
  <div class="datepicker-form-control__label">
    {{label()}} @if(required()){
    <span class="datepicker-form-control__required"> * </span>
    }
  </div>
  }
  <div
    #control
    [attr.tabindex]="(disabled() || readonly() )? -1 : 0"
    (focusin)="onFocus()"
    (focusout)="onBlur()"
    class="datepicker-form-control__control">
    @if (showControl()) {
    <date-input-form-control
      [value]="value() ?? null"
      (valueChange)="onDateInputChanged($event)"
      (focused)="onDateFocused()"
      (blurred)="onDateBlurred()"
      [disabled]="disabled()"
      [readonly]="readonly()"
      class="datepicker-form-control__date-input" />
    }

    <div
      (clickOutside)="calendarOpen.set(false)"
      [clickOutsideEnabled]="calendarOpen()"
      class="datepicker-form-control__calendar">
      <div
        (click)="toggleCalendar()"
        class="datepicker-form-control__calendar-icon">
        <calendar-bulk />
      </div>

      @if (calendarOpen()) {
      <calendar-form-control
        [minDate]="minDate()"
        [maxDate]="maxDate()"
        [selectedDate]="value()"
        (selectedDateChange)="onSelect($event)"
        class="datepicker-form-control__calendar-modal" />
      }
    </div>
  </div>
  <form-control-meta
    [errors]="errors()"
    [helper]="helper()"
    [max]="max()"
    [showErrors]="showErrors()"
    [state]="feedbackState()"
    [valueLength]="valueLength()" />
</div>
